module.exports = "<div [ngClass]=\"{'control': control}\" (click)=\"click()\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/editor/pin/pin.component.html
// module id = ./src/app/components/editor/pin/pin.component.html
// module chunks = main